var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_262_10266",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
          },
        },
        [_c("rect", { attrs: { width: "20", height: "20", fill: "#D9D9D9" } })]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_262_10266)" } }, [
        _c("path", {
          attrs: {
            d: "M7.74917 15H12.2442C12.4564 15 12.6354 14.9285 12.7812 14.7856C12.9271 14.6427 13 14.4656 13 14.2544C13 14.0431 12.9282 13.8646 12.7846 13.7188C12.641 13.5729 12.4631 13.5 12.2508 13.5H7.75583C7.54361 13.5 7.36458 13.5715 7.21875 13.7144C7.07292 13.8573 7 14.0344 7 14.2456C7 14.4569 7.07181 14.6354 7.21542 14.7812C7.35903 14.9271 7.53694 15 7.74917 15ZM7.74917 12H12.2442C12.4564 12 12.6354 11.9285 12.7812 11.7856C12.9271 11.6427 13 11.4656 13 11.2544C13 11.0431 12.9282 10.8646 12.7846 10.7188C12.641 10.5729 12.4631 10.5 12.2508 10.5H7.75583C7.54361 10.5 7.36458 10.5715 7.21875 10.7144C7.07292 10.8573 7 11.0344 7 11.2456C7 11.4569 7.07181 11.6354 7.21542 11.7812C7.35903 11.9271 7.53694 12 7.74917 12ZM5.49417 18C5.08139 18 4.72917 17.8531 4.4375 17.5594C4.14583 17.2656 4 16.9125 4 16.5V3.5C4 3.0875 4.14687 2.73438 4.44062 2.44063C4.73437 2.14688 5.0875 2 5.5 2H11.375C11.5725 2 11.7608 2.03472 11.9398 2.10417C12.1188 2.17361 12.2847 2.28472 12.4375 2.4375L15.5625 5.5625C15.7153 5.71528 15.8264 5.88118 15.8958 6.06021C15.9653 6.23924 16 6.4275 16 6.625V16.5C16 16.9125 15.8531 17.2656 15.5592 17.5594C15.2653 17.8531 14.9119 18 14.4992 18H5.49417ZM11 6.25V3.5H5.5V16.5H14.5V7H11.75C11.5375 7 11.3594 6.92813 11.2156 6.78438C11.0719 6.64063 11 6.4625 11 6.25Z",
            fill: "#8796AF",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }